import { render, staticRenderFns } from "./Abattoir.vue?vue&type=template&id=409af3cd"
import script from "./Abattoir.vue?vue&type=script&lang=ts"
export * from "./Abattoir.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports